import { Card, Table, Tag, Space } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import axiosInstance from '@/lib/axios'

interface RdaRow {
  id: number
  codice?: string
  work_order_id?: number
  cliente_nome?: string
  targa?: string
  costo_stimato_totale?: number
  fornitore?: string
  purchase_request_status_nome?: string
}

const columns = [
  {
    title: 'RDA',
    dataIndex: 'codice',
    key: 'codice',
    width: 130,
    render: (v: string, r: RdaRow) => (
      <Space size={4}>
        <span style={{ fontWeight: 600, color: '#1677ff' }}>{v ?? '—'}</span>
        {r.cliente_nome && <span style={{ color: '#888', fontSize: 12 }}>· {r.cliente_nome}</span>}
      </Space>
    ),
  },
  {
    title: 'Stato',
    dataIndex: 'purchase_request_status_nome',
    key: 'stato',
    width: 110,
    render: (v: string) => <Tag color="red">{v ?? '—'}</Tag>,
  },
  {
    title: 'Veicolo',
    dataIndex: 'targa',
    key: 'targa',
    width: 100,
    render: (v: string) => v ? <Tag color="geekblue">{v}</Tag> : '—',
  },
  {
    title: 'Fornitore',
    dataIndex: 'fornitore',
    key: 'fornitore',
    ellipsis: true,
    render: (v: string) => v ?? '—',
  },
]

export function TableRdaRifiutateWidget() {
  const navigate = useNavigate()
  const { data, isLoading } = useQuery<RdaRow[]>({
    queryKey: ['dashboard', 'rda-rifiutate-list'],
    queryFn: async () => {
      const res = await axiosInstance.get('/purchase-requests/', {
        params: { stato_nome: 'Rifiutata', limit: 20 },
      })
      return Array.isArray(res.data) ? res.data : []
    },
    staleTime: 30000,
  })

  return (
    <Card size="small" title="RDA rifiutate">
      <Table
        columns={columns}
        dataSource={data ?? []}
        rowKey="id"
        size="small"
        loading={isLoading}
        pagination={false}
        scroll={{ x: 480 }}
        locale={{ emptyText: 'Nessuna RDA rifiutata' }}
        onRow={(r) => ({
          onClick: () => navigate('/rda', { state: { expandWorkOrderId: r.work_order_id } }),
          style: { cursor: 'pointer' },
        })}
      />
    </Card>
  )
}
